import React, {FC} from "react";
import {useHistory} from "react-router-dom";
import {useDispatch, batch} from "react-redux";
import {menuInactive} from "../menu/menu-slice";
import {changeCurrentPage} from "../../pages/pages-slice";
import {setCasesType} from "../../pages/event-agency-information/information-modules/cases/cases-slice";
import logo from "./img/logo.svg"
import logoRed from "./img/logo_red.svg"
import "./logo.scss"
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {ILogoProps} from "../../../ts/interfaces/interfaces";

const Logo:FC<ILogoProps> = ({filter, style}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {menuState} = useTypedSelector(state => state.menu)
    const {currentPage} = useTypedSelector(state => state.pages);
    const {casesType} = useTypedSelector(state => state.cases)
    return(
        <div
            onClick={()=>(
                history.push("/"),
                    currentPage !== "main-page" ? (
                        batch(()=>(
                            dispatch(changeCurrentPage("main-page")),
                            casesType !== "" ? dispatch(setCasesType("")) : null,
                            menuState !== "inactive" ? dispatch(menuInactive()) : null
                        ))
                ) : null
                )}
            className={`logo-block`}
        style={style}>
            <h1 className={`logo-name${filter ? " "+filter : ""}`}>Relanta Event Agency</h1>
            <img
                src={filter==="filter_red" ? logoRed : logo}
                className={`logo-img${filter==="filter_black" ? " " + filter : ""}`}
                alt={"relanta-logo.svg"}/>
        </div>
    )
}

export default  Logo